<script setup lang="ts">
import { RouterLink } from "vue-router";

const props = defineProps<{
    to: string;
}>();
</script>

<template>
    <RouterLink class="underline" :to="props.to">
        <slot></slot>
    </RouterLink>
</template>
